export const emploiDuTemps = [
  // Semaine du 2 septembre
  {
    date: "2025-09-01", // lundi
    jour: "Lundi",
    heure: "08:00 - 09:00",
    matiere: "Mathématiques",
    salle: "A101",
    classe: "6e A",
    prof: "Mme Dupont",
  },
  {
    date: "2025-09-01",
    jour: "Lundi",
    heure: "09:00 - 10:00",
    matiere: "Histoire",
    salle: "B203",
    classe: "5e B",
    prof: "M. Martin",
  },
  {
    date: "2025-09-02",
    jour: "Mardi",
    heure: "10:00 - 11:00",
    matiere: "SVT",
    salle: "C102",
    classe: "4e C",
    prof: "Mme Lefevre",
  },
  {
    date: "2025-09-03",
    jour: "Mercredi",
    heure: "13:00 - 14:00",
    matiere: "Anglais",
    salle: "A301",
    classe: "6e A",
    prof: "M. Smith",
  },
  {
    date: "2025-09-04",
    jour: "Jeudi",
    heure: "14:00 - 15:00",
    matiere: "Physique",
    salle: "B105",
    classe: "5e B",
    prof: "Mme Curie",
  },
  {
    date: "2025-09-05",
    jour: "Vendredi",
    heure: "15:00 - 16:00",
    matiere: "EPS",
    salle: "Gymnase",
    classe: "4e C",
    prof: "M. Lopez",
  },

  // Semaine suivante : 8 au 12 septembre
  {
    date: "2025-09-08",
    jour: "Lundi",
    heure: "08:00 - 09:00",
    matiere: "Mathématiques",
    salle: "A101",
    classe: "6e A",
    prof: "Mme Dupont",
  },
  {
    date: "2025-09-08",
    jour: "Lundi",
    heure: "09:00 - 10:00",
    matiere: "Histoire",
    salle: "B203",
    classe: "5e B",
    prof: "M. Martin",
  },
  {
    date: "2025-09-09",
    jour: "Mardi",
    heure: "10:00 - 11:00",
    matiere: "SVT",
    salle: "C102",
    classe: "4e C",
    prof: "Mme Lefevre",
  },
  {
    date: "2025-09-10",
    jour: "Mercredi",
    heure: "13:00 - 14:00",
    matiere: "Anglais",
    salle: "A301",
    classe: "6e A",
    prof: "M. Smith",
  },
  {
    date: "2025-09-11",
    jour: "Jeudi",
    heure: "14:00 - 15:00",
    matiere: "Physique",
    salle: "B105",
    classe: "5e B",
    prof: "Mme Curie",
  },
  {
    date: "2025-09-12",
    jour: "Vendredi",
    heure: "15:00 - 16:00",
    matiere: "EPS",
    salle: "Gymnase",
    classe: "4e C",
    prof: "M. Lopez",
  },

  // Semaine du 15 au 19 septembre
  {
    date: "2025-09-15",
    jour: "Lundi",
    heure: "08:00 - 09:00",
    matiere: "Mathématiques",
    salle: "A101",
    classe: "6e A",
    prof: "Mme Dupont",
  },
  {
    date: "2025-09-15",
    jour: "Lundi",
    heure: "09:00 - 10:00",
    matiere: "Histoire",
    salle: "B203",
    classe: "5e B",
    prof: "M. Martin",
  },
  {
    date: "2025-09-16",
    jour: "Mardi",
    heure: "10:00 - 11:00",
    matiere: "SVT",
    salle: "C102",
    classe: "4e C",
    prof: "Mme Lefevre",
  },
  {
    date: "2025-09-17",
    jour: "Mercredi",
    heure: "13:00 - 14:00",
    matiere: "Anglais",
    salle: "A301",
    classe: "6e A",
    prof: "M. Smith",
  },
  {
    date: "2025-09-18",
    jour: "Jeudi",
    heure: "14:00 - 15:00",
    matiere: "Physique",
    salle: "B105",
    classe: "5e B",
    prof: "Mme Curie",
  },
  {
    date: "2025-09-19",
    jour: "Vendredi",
    heure: "15:00 - 16:00",
    matiere: "EPS",
    salle: "Gymnase",
    classe: "4e C",
    prof: "M. Lopez",
  },

   // 🔔 Cours pour aujourd’hui : 28 juillet 2025
  {
    date: "2025-07-28",
    jour: "Lundi",
    heure: "08:00 - 09:00",
    matiere: "Mathématiques",
    salle: "A101",
    classe: "6e A",
    prof: "Mme Dupont",
  },
  {
    date: "2025-07-28",
    jour: "Lundi",
    heure: "10:00 - 11:00",
    matiere: "Français",
    salle: "B201",
    classe: "6e A",
    prof: "M. Bernard",
  },
  {
    date: "2025-07-28",
    jour: "Lundi",
    heure: "14:00 - 15:00",
    matiere: "Technologie",
    salle: "Tech01",
    classe: "6e A",
    prof: "Mme Rousseau",
  },
  {
    date: "2025-09-01", // lundi
    jour: "Lundi",
    heure: "08:00 - 09:00",
    matiere: "Mathématiques",
    salle: "A101",
    classe: "6e A",
    prof: "Mme Dupont",
  },

  {
    date: "2025-07-01",
    jour: "Lundi",
    heure: "09:00 - 10:00",
    matiere: "Histoire",
    salle: "B203",
    classe: "5e B",
    prof: "M. Martin",
  },
  {
    date: "2025-07-02",
    jour: "Mardi",
    heure: "10:00 - 11:00",
    matiere: "SVT",
    salle: "C102",
    classe: "4e C",
    prof: "Mme Lefevre",
  },
  {
    date: "2025-07-31",
    jour: "Mercredi",
    heure: "13:00 - 14:00",
    matiere: "Anglais",
    salle: "A301",
    classe: "6e A",
    prof: "M. Smith",
  },
  {
    date: "2025-07-04",
    jour: "Jeudi",
    heure: "14:00 - 15:00",
    matiere: "Physique",
    salle: "B105",
    classe: "5e B",
    prof: "Mme Curie",
  },
  {
    date: "2025-07-05",
    jour: "Vendredi",
    heure: "15:00 - 16:00",
    matiere: "EPS",
    salle: "Gymnase",
    classe: "4e C",
    prof: "M. Lopez",
  },
   {
    date: "2025-07-31",
    jour: "Mercredi",
    heure: "16:00 - 17:00",
    matiere: "EPS",
    salle: "Gymnase",
    classe: "4e C",
    prof: "M. Lopez",
  },
   {
    date: "2025-07-31",
    jour: "Mercredi",
    heure: "8:00 - 12:00",
    matiere: "EPS",
    salle: "Gymnase",
    classe: "4e C",
    prof: "M. Lopez",
  },

];
